import ApiService from '@/services/api.service';
import { TokenService, UserStorageService } from '@/services/storage.service';
import helpers from '@/lib/helpers';

class AuthenticationError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

class RequestError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const OffersService = {
  async getOffers(params) {
    const response = await ApiService.get('/offers/dashboard_index', { params });
    return response.data;
  },

  async patchOffer(payload = {}) {
    try {
      const response = await ApiService.patchFormData(`/offers/${payload.get('offer[id]')}`, payload);

      return response.data;
    } catch (error) {
      helpers.showMessage(error.response, 'error');
      throw error;
    }
  },

  async createOffer(payload) {
    try {
      const response = await ApiService.postFormData('/offers', payload);

      return response.data;
    } catch (error) {
      helpers.showMessage(error.response, 'error');
      throw error;
    }
  },

  async deleteOffer(id) {
    try {
      await ApiService.post(`/offers/delete_all`, {
        id
      });

      return true;
    } catch (error) {
      helpers.showMessage(error.response, 'error');
    }
  },
};


export {
    OffersService, AuthenticationError, RequestError,
};
